/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomguestsweekly3Inputs */

const en_statsroomguestsweekly3 = /** @type {(inputs: Statsroomguestsweekly3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests per week`)
};

const de_statsroomguestsweekly3 = /** @type {(inputs: Statsroomguestsweekly3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gäste pro Woche`)
};

/**
* | output |
* | --- |
* | "Guests per week" |
*
* @param {Statsroomguestsweekly3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomguestsweekly3 = /** @type {((inputs?: Statsroomguestsweekly3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomguestsweekly3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomguestsweekly3(inputs)
	return de_statsroomguestsweekly3(inputs)
});
export { statsroomguestsweekly3 as "statsRoomGuestsWeekly" }